// import '../css/Profile.css';
import { useEffect } from 'react';
import { Tabs } from '../components/Tabs';
import { useUser } from '../hooks/useUser';
import { useNavigate } from 'react-router-dom';
import UploadVideos from '../forms/UploadVideo';
import UploadSong from '../forms/UploadNewSong';
import { MySongs } from '../components/Songs/MySongs';
import { MyVideos } from '../components/Videos/MyVideos';
import { Calendar } from '../components/Calendar/CalandarBody';
import { Messages } from '../components/Messages/Messages';
// import { Feed } from '../features/Feed';
// import Search from '../features/Search';
// import { Chats } from '../components/Chats';
// import MyCallOuts from '../components/MyCallOuts';
// import { Followers } from '../components/Followers';
// import useRenderCounter from '../services/checkRender';

// import { Merch } from '../components/Merch';
// import { useChats } from '../hooks/useChats';
// import { ManageWallet } from '../components/ManageWallet';

export default function Profile() {
  //   useRenderCounter('PROFILE');
  //   const { unreadMessagesCount } = useChats();
  // console.log('WHY IS MY MESSAGE COUNT NOT SHOWING IN THE TAB???', unreadMessagesCount);

  const { user, isLoggedIn } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate('/login');
    }
  }, [user, isLoggedIn, navigate]);

  const profile = {
    tabs: [
      'My Videos',
      'My Songs',
      'Calendar',
      'Messages',
      'Upload Video',
      'Upload Song',
      //   `${unreadMessagesCount === 0 ? 'Messages' : `Messages ${unreadMessagesCount}`}`,
      //   'My CallOuts',
      //   'Search',
      //   'Feed',
      //   'Followers',
      //   'Merch',
      //   'Manage Wallet',
    ],

    content: [
      <MyVideos key={'videos'} profile={user!} />,
      <MySongs key={'songs'} profile={user!} />,
      <Calendar key={'calendar'} useCase={'private'} profile={user!} />,
      <Messages key={'user-profile-messages'} />,
      <UploadVideos key={'upload-video-component'} />,
      <UploadSong key={'upload-song-component'} />,
      //   <MyCallOuts key={'call-outs'} />,
      //   <Search key={'search'} />,
      //   <Feed key={'feed'} />,
      //   <Followers key={'followers'} />,
      //   <Merch key={'merchandise'} />,
      //   <ManageWallet key={'Manage-wallet'} />,
    ],
    modal: false,
  };

  return (
    user && (
      <div className="profile-container">
        <span className="profile-page-tabs-span">
          <Tabs page={profile} />
        </span>
      </div>
    )
  );
}
